<template>
  <div class="devpage-page">
    <van-pull-refresh v-model="isLoading" @refresh="onReflash" class="devpage-index">
      <div v-if="devdata">
        <van-nav-bar left-arrow class="crystal-nav" @click-right="devconfigshow = true" @click-left="gotohome">
          <template #left>
            <van-icon name="arrow-left" size="20px" color="#475569" />
          </template>
          <template #right>
            <van-icon name="setting-o" size="20px" color="#94a3b8" />
          </template>
          <template #title>
            <div class="nav-title-wrap">
              <span class="nav-devname">{{ devdata.udname }}</span>
              <span class="nav-did">{{ did }}</span>
            </div>
          </template>
        </van-nav-bar>

        <van-action-sheet v-model="devconfigshow" :actions="actions" cancel-text="取消" @select="onSelect"
          :title="devdata.udname" class="crystal-actionsheet" />

        <DevGroup v-if="devgroupcard" :did="devdata.did" @configstatus="configstatus($event)"></DevGroup>
        <DevName v-if="devnamecard" :did="devdata.did" @configstatus="configstatus($event)"></DevName>
        <DevUnbind v-if="devunbindcard" :did="devdata.did" @configstatus="configstatus($event)"></DevUnbind>

        <div class="status-block" :class="devdata.value.ws === 1 ? 'status-block--on' : 'status-block--off'">
          <div class="status-inner">
            <span class="iconfont icon-bushuitubiao status-icon"></span>
            <div class="status-text">
              <span v-if="devdata.value.ts == 1" style="color: #fb7185;">低温保护</span>
              <span v-else>{{ devdata.value.ws === 1 ? '正在补水' : devdata.value.ptb == 0 ? '补水已结束' : '已暂停' }}</span>
              <div v-if="devdata.value.wto != 0" class="status-sub">补水超时{{ devdata.value.wto }}秒</div>
            </div>
          </div>
        </div>

        <div class="content-area">
          <div class="info-card">
            <div v-if="devdata.value.work_error" class="alert-bar">
              <span class="iconfont icon-alarm alert-icon"></span>
              <span v-if="devdata.value.work_error == -1" class="alert-text">补水超时</span>
              <span v-else-if="devdata.value.work_error == -2" class="alert-text">水泵无水</span>
              <button class="alert-btn" @click="clean_error">清除告警</button>
            </div>
            <div v-if="err_str" class="alert-bar">
              <span class="iconfont icon-alarm alert-icon"></span>
              <span class="alert-text">{{ err_str }}</span>
            </div>

            <div class="info-item">
              <div class="info-item-left">
                <span class="iconfont icon-zidong1 info-icon" style="color: #2dd4bf"></span>
                <span class="info-label">工作模式</span>
              </div>
              <van-radio-group v-model="work_mode" direction="horizontal" class="info-radio">
                <van-radio :name="0" @click="change_work_mode" class="crystal-radio">自动</van-radio>
                <van-radio :name="1" @click="change_work_mode" class="crystal-radio">手动</van-radio>
              </van-radio-group>
            </div>
            <div class="info-divider"></div>

            <div class="info-item">
              <div class="info-item-left">
                <span class="iconfont icon-switch info-icon" style="color: #2dd4bf"></span>
                <span class="info-label">手动补水</span>
              </div>
              <button v-if="devdata.value.ws === 0" class="info-btn info-btn--primary"
                @click="start_bushui(1)">开启补水</button>
              <button v-else-if="devdata.value.ws === 1" class="info-btn info-btn--warn"
                @click="start_bushui(0)">结束补水</button>
            </div>
            <div class="info-divider"></div>

            <div class="info-item">
              <div class="info-item-left">
                <span class="iconfont icon-zanting info-icon" style="color: #2dd4bf"></span>
                <span class="info-label">暂停补水</span>
              </div>
              <button v-if="devdata.value.ptb == 0" class="info-btn info-btn--primary" @click="start_pause">暂停</button>
              <button v-else class="info-btn info-btn--danger" @click="stop_pause">{{ Math.floor(devdata.value.ptb /
                3600) }}:{{
                  Math.floor(devdata.value.ptb / 60) }}:{{ devdata.value.ptb % 60 }}</button>
            </div>
            <div class="info-divider"></div>

            <div class="info-item">
              <div class="info-item-left">
                <span class="iconfont icon-shuiwei info-icon" style="color:#2dd4bf"></span>
                <span class="info-label">水位</span>
              </div>
              <span :class="devdata.value.wl == 1 ? 'value-normal' : 'value-danger'">
                {{ devdata.value.wl == 1 ? '正常' : '水位低' }}
              </span>
            </div>
            <div class="info-divider"></div>

            <div class="info-item">
              <div class="info-item-left">
                <span class="iconfont icon-wendu1 info-icon" style="color:#2dd4bf"></span>
                <span class="info-label">温度</span>
              </div>
              <span class="value-normal">{{ devdata.value.temp }}℃</span>
            </div>
          </div>

          <div class="info-card">
            <div class="info-item info-item--link" @click="gotolog()">
              <div class="info-item-left">
                <span class="iconfont icon-date info-icon" style="color:#2dd4bf"></span>
                <span class="info-label">补水日志</span>
              </div>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 4L10 8L6 12" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            <div class="info-divider"></div>
            <div class="info-item info-item--link" @click="gotoconfig()">
              <div class="info-item-left">
                <span class="iconfont icon-sinaweibo18 info-icon" style="color:#2dd4bf"></span>
                <span class="info-label">参数设置</span>
              </div>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 4L10 8L6 12" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
          </div>

          <div class="history-section">
            <div class="history-tabs">
              <button v-for="(tab, i) in historyTabs" :key="i" class="history-tab" :class="getHistoryClass(i)"
                @click="gethistory(tab.tnum, tab.tunit)">{{ tab.label }}</button>
            </div>
            <div class="chart-card">
              <div id="tempChart" class="history-chart"></div>
            </div>
          </div>
        </div>
      </div>

    </van-pull-refresh>
  </div>
</template>

<script>
import DevGroup from "../general/apidevgroup.vue";
import DevName from "../general/apidevname.vue";
import DevUnbind from "../general/apidevunbind.vue";

export default {
  name: "DevPageSC2",
  components: {
    DevGroup,
    DevName,
    DevUnbind,
  },
  data() {
    return {
      historyTabs: [
        { label: "1小时", tnum: 1, tunit: "hour" },
        { label: "6小时", tnum: 6, tunit: "hour" },
        { label: "1天", tnum: 1, tunit: "day" },
        { label: "1周", tnum: 7, tunit: "day" },
      ],
      history1: "",
      history2: "",
      history3: "",
      history4: "",

      templist: [],
      temptimelist: [],

      err_str: "",
      work_mode: 0,
      de_setdata: {
        time: 0,
        socket: 0,
      },

      connection: {
        url: "wss://dev.kudutech.cn/mqtt",
        clean: true,
        clientId: this.$route.query.did + this.generateUUID(),
        username: "KD-1web",
        password: "KD-1web",
      },
      subscription: {
        topic: "kd/dev/KD-1/" + this.$route.query.did + "/push",
        qos: 1,
      },
      client: {
        connected: false,
      },

      dialogFormVisible: false,
      devconfigshow: false,
      devgroupcard: false,
      devnamecard: false,
      devunbindcard: false,

      isLoading: false,

      devdata: null,
      socketsatu: 0,
      udname: "",
      did: this.$route.query.did,
      actions: [
        { name: "更改分组", color: "#2dd4bf" },
        { name: "重命名", color: "#2dd4bf" },
        { name: "解绑", color: "#fb7185" },
      ],
    };
  },
  mounted() {
    this.GetDevData(this.did);
    this.createConnection();
    this.doSubscribe();
  },
  watch: {
    devdata: {
      handler(val) {
        if (val) {
          this.gethistory(1, "hour");
        }
      },
      immediate: false,
    },
  },
  beforeDestroy() {
    if (this.client.connected) {
      try {
        this.client.end();
        this.client = { connected: false };
      } catch (error) { }
    }
  },
  methods: {
    getHistoryClass(i) {
      const map = [this.history1, this.history2, this.history3, this.history4];
      return map[i] && map[i].history1 ? "history-tab--active" : "";
    },
    generateUUID() {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === "function") {
        d += performance.now();
      }
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g, function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    createConnection() {
      const { url, ...options } = this.connection;
      try {
        if (!this.client.connected) {
          this.client = mqtt.connect(url, options);
        }
      } catch (error) { }
      this.client.on("connect", () => { console.log("Connection succeeded!"); });
      this.client.on("error", (error) => { });
      this.client.on("message", (topic, message) => {
        var datastr = `${message}`.replace(/\'/g, '"');
        this.resolve_data(JSON.parse(datastr));
      });
    },
    doSubscribe() {
      try {
        const { topic, qos } = this.subscription;
        this.client.subscribe(topic, qos, (error, res) => {
          if (error) return;
        });
      } catch (error) {
        console.warn("MQTT subscribe failed:", error);
      }
    },
    resolve_data(data_buf, type) {
      console.log("mqtt接收: ", data_buf);
      if (data_buf["m_type"] === "push") {
        this.devdata.action = data_buf.action;
        this.devdata.value = data_buf.value;
        this.devdata.err = data_buf.err;
        this.work_mode = this.devdata.config.red[0];
        this.err_str = "";
        if (this.devdata.err[0] == -1) this.err_str = "温度高 ";
        else if (this.devdata.err[0] == -2) this.err_str = "温度低 ";
        this.$forceUpdate();
      }
    },
    change_work_mode() {
      this.send_config({ work_mode: this.work_mode });
    },
    clean_error() {
      this.send_config({ work_error: 0 });
    },
    stop_pause() {
      this.$dialog.confirm({ title: "暂停补水？", message: "" })
        .then(() => { this.send_config({ stop_pause: 1 }); })
        .catch(() => { });
    },
    start_pause() {
      this.$dialog.confirm({ title: "暂停补水？", message: "" })
        .then(() => { this.send_config({ start_pause: 1 }); })
        .catch(() => { });
    },
    start_bushui(ac) {
      this.$dialog.confirm({ title: ac == 1 ? "开启手动补水？" : "结束补水？", message: "" })
        .then(() => { this.send_config({ work_manual: ac }); })
        .catch(() => { });
    },
    send_config(data) {
      const qs = require("qs");
      var databuf = JSON.stringify(data);
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.devdata.did,
          d_type: "KD-1",
          config: databuf,
        }))
        .then((response) => {
          this.GetDevData(this.did);
          if (response.data.error_code != 0) {
            this.$notify({ type: "danger", message: "设置失败！" });
          } else {
            this.$notify({ type: "success", message: "设置成功！" });
          }
        })
        .catch((error) => {
          this.GetDevData(this.did);
          this.$notify({ type: "danger", message: "设置失败！" });
        });
    },
    devrefresh() {
      this.isLoading = true;
      const qs = require("qs");
      var databuf = JSON.stringify({ a: 2 });
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.devdata.did,
          d_type: "KD-1",
          config: databuf,
        }))
        .then((response) => {
          this.isLoading = false;
          if (response.data.error_code === 0) {
            this.GetDevData(this.did);
          }
        })
        .catch((error) => { this.isLoading = false; });
    },
    onSelect(item) {
      this.devconfigshow = false;
      if (item.name === "重命名") { this.devnamecard = true; }
      else if (item.name === "更改分组") { this.devgroupcard = true; }
      else if (item.name === "解绑") { this.devunbindcard = true; }
      else if (item.name === "设置报警") { this.dialogFormVisible = true; }
    },
    configstatus(statu) {
      this.devgroupcard = false;
      this.devnamecard = false;
      this.devunbindcard = false;
      this.dialogFormVisible = false;
      this.GetDevData(this.did);
      if (statu === true) { this.$toast.success("设置成功"); }
    },
    GetDevData(did) {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/one", qs.stringify({ did: did }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.isLoading = false;
            this.devdata = response.data;
            this.work_mode = this.devdata.config.red[0];
            this.err_str = "";
            if (this.devdata.err[0] == -1) this.err_str = "温度高 ";
            else if (this.devdata.err[0] == -2) this.err_str = "温度低 ";
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          } else {
            this.$router.push({ path: "/devlist" });
          }
        });
    },
    gethistory(tnum, tunit) {
      this.overlay = true;
      this.history1 = "";
      this.history2 = "";
      this.history3 = "";
      this.history4 = "";
      if (tnum === 1 && tunit === "hour") { this.history1 = { history1: true }; }
      else if (tnum === 6 && tunit === "hour") { this.history2 = { history1: true }; }
      else if (tnum === 1 && tunit === "day") { this.history3 = { history1: true }; }
      else if (tnum === 7 && tunit === "day") { this.history4 = { history1: true }; }

      const qs = require("qs");
      this.$axios
        .post("/api/dev/kd1/history", qs.stringify({ did: this.did, tnum: tnum, tunit: tunit }))
        .then((response) => {
          this.overlay = false;
          if (response.data.error_code === 0) {
            this.templist = [];
            this.temptimelist = [];
            for (var row of response.data.data.temp_buf) {
              this.templist.push(row.v);
              this.temptimelist.push(row.t);
            }
            this.drawtempLine();
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          }
        });
    },
    drawtempLine() {
      this.$nextTick(() => {
        var chartDom = document.getElementById("tempChart");
        if (!chartDom) return;
        let volChart = echarts.init(chartDom);
        var option = {
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255,255,255,0.95)",
            borderColor: "#e2e8f0",
            borderWidth: 1,
            textStyle: { color: "#475569", fontSize: 12, fontFamily: "Inter, Noto Sans SC, sans-serif" },
            formatter: function (params) {
              return '<div style="font-weight:600;color:#1e293b;font-size:13px;margin-bottom:4px">' + params[0].axisValue + '</div>' +
                '<div style="display:flex;align-items:center;gap:6px;padding:2px 0">' +
                '<span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#2dd4bf"></span>' +
                '<span style="color:#64748b">' + params[0].seriesName + '：</span>' +
                '<span style="color:#1e293b;font-weight:600">' + params[0].value + '℃</span></div>';
            }
          },
          grid: { left: "8%", right: "8%", top: "8%", bottom: "18%" },
          xAxis: {
            type: "category", data: this.temptimelist,
            axisLine: { lineStyle: { color: "#e2e8f0" } },
            axisTick: { show: false },
            axisLabel: { color: "#94a3b8", fontSize: 10, fontWeight: 400 },
            splitLine: { show: false },
          },
          yAxis: {
            type: "value",
            name: "温度/℃",
            nameTextStyle: { color: "#94a3b8" },
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: { color: "#94a3b8", fontSize: 10, fontWeight: 400 },
            splitLine: { lineStyle: { color: "#f1f5f9", type: "dashed" } },
          },
          dataZoom: [{
            type: "slider", start: 0, end: 100,
            height: 24, bottom: 24,
            borderColor: "#e2e8f0", backgroundColor: "#f8fafc",
            fillerColor: "rgba(45,212,191,0.1)",
            handleStyle: { color: "#2dd4bf" },
            textStyle: { color: "#94a3b8", fontSize: 10 },
          }],
          series: {
            name: "温度",
            data: this.templist,
            type: "line",
            symbol: "none",
            smooth: true,
            lineStyle: { color: "#2dd4bf", width: 2 },
            areaStyle: { color: "rgba(45,212,191,0.06)" },
            itemStyle: { color: "#2dd4bf" },
          },
        };
        volChart.setOption(option);
      });
    },
    onReflash() { this.devrefresh(); },
    gotohome() { this.$router.go(-1); },
    gototime() { this.$router.push({ name: "KD1timing", query: { did: this.did } }); },
    gotoconfig() { this.$router.push({ name: "KD1Config", query: { did: this.did } }); },
    gotolog() { this.$router.push({ name: "KD1Log", query: { did: this.did, udname: this.devdata.udname } }); },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap");

.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}

.crystal-nav .van-nav-bar__title {
  max-width: 70%;
}

.nav-title-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.3;
}

.nav-devname {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.nav-did {
  font-size: 11px;
  color: #94a3b8;
}

.crystal-actionsheet .van-action-sheet__header {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.crystal-radio .van-radio__label {
  font-size: 13px;
  color: #475569;
}

.crystal-radio .van-radio__icon--checked .van-icon {
  background-color: #2dd4bf;
  border-color: #2dd4bf;
}

.history-chart {
  height: 280px;
  width: 100%;
}
</style>

<style scoped>
.devpage-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
  font-family: "Inter", "Noto Sans SC", sans-serif;
}

.devpage-index {
  background: transparent !important;
  padding-bottom: 20px;
  min-height: 100vh;
  min-height: 100dvh;
}

.status-block {
  margin: 12px 12px 0;
  border-radius: 18px;
  padding: 24px;
  text-align: center;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);
}

.status-block--on {
  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
  color: #fff;
}

.status-block--off {
  background: #94a3b8;
  color: #fff;
}

.status-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.status-icon {
  font-size: 100px;
  line-height: 1.2;
  opacity: 0.9;
}

.status-text {
  font-size: 18px;
  font-weight: 600;
}

.status-sub {
  font-size: 13px;
  font-weight: 400;
  opacity: 0.8;
  margin-top: 2px;
}

.content-area {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.alert-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff1f2;
  border-radius: 14px;
  padding: 10px 14px;
}

.alert-bar + .alert-bar {
  margin-top: 8px;
}

.alert-icon {
  font-size: 18px;
  color: #fb7185;
  flex-shrink: 0;
}

.alert-text {
  flex: 1;
  font-size: 13px;
  color: #e11d48;
  font-weight: 500;
}

.alert-btn {
  height: 30px;
  padding: 0 14px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  background: #fb7185;
  color: #fff;
  font-family: inherit;
  flex-shrink: 0;
  transition: transform 0.15s;
}

.alert-btn:active {
  transform: scale(0.95);
}

.info-card {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.info-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  min-height: 24px;
}

.info-item--link {
  cursor: pointer;
  transition: background 0.15s;
}

.info-item--link:active {
  background: #f8fafc;
}

.info-item-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-icon {
  font-size: 17px;
  flex-shrink: 0;
}

.info-label {
  font-size: 14px;
  font-weight: 500;
  color: #475569;
}

.info-radio {
  display: flex;
  gap: 4px;
}

.info-divider {
  height: 1px;
  background: #f1f5f9;
  margin: 0 16px;
}

.info-btn {
  height: 32px;
  padding: 0 16px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: transform 0.15s;
}

.info-btn:active {
  transform: scale(0.95);
}

.info-btn--primary {
  background: rgba(45, 212, 191, 0.15);
  color: #0d9488;
}

.info-btn--warn {
  background: rgba(251, 191, 36, 0.15);
  color: #d97706;
}

.info-btn--danger {
  background: #fb7185;
  color: #fff;
}

.value-normal {
  font-size: 14px;
  font-weight: 500;
  color: #475569;
}

.value-danger {
  font-size: 14px;
  font-weight: 500;
  color: #fb7185;
}

.history-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.history-tabs {
  display: flex;
  gap: 8px;
  justify-content: center;
  padding: 0 4px;
}

.history-tab {
  flex: 1;
  height: 32px;
  padding: 0 4px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.2s;
  white-space: nowrap;
  text-align: center;
}

.history-tab--active {
  background: #2dd4bf;
  color: #fff;
}

.history-tab:not(.history-tab--active) {
  background: #f1f5f9;
  color: #94a3b8;
}

.history-tab:not(.history-tab--active):active {
  background: #e2e8f0;
}

.chart-card {
  background: #ffffff;
  border-radius: 18px;
  padding: 12px 8px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
}
</style>
